/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_metric_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentences`)
};

const es_ra_metric_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oraciones`)
};

const de_ra_metric_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sätze`)
};

const nl_ra_metric_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zinnen`)
};

const fr_ra_metric_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrases`)
};

const it_ra_metric_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frasi`)
};

const pt_br2_ra_metric_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentenças`)
};

const pt_ra_metric_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frases`)
};

const ja_ra_metric_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文数`)
};

const zh_ra_metric_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`句数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_metric_sentences = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_metric_sentences(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_metric_sentences", locale)
	if (locale === "en") return en_ra_metric_sentences(inputs)
	if (locale === "es") return es_ra_metric_sentences(inputs)
	if (locale === "de") return de_ra_metric_sentences(inputs)
	if (locale === "nl") return nl_ra_metric_sentences(inputs)
	if (locale === "fr") return fr_ra_metric_sentences(inputs)
	if (locale === "it") return it_ra_metric_sentences(inputs)
	if (locale === "pt-BR") return pt_br2_ra_metric_sentences(inputs)
	if (locale === "pt") return pt_ra_metric_sentences(inputs)
	if (locale === "ja") return ja_ra_metric_sentences(inputs)
	return zh_ra_metric_sentences(inputs)
};